import React, { useState, useEffect, useCallback } from 'react';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import * as _ from 'lodash';
import { FiEdit2 } from 'react-icons/fi';
import { RiDeleteBinLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import Card from 'components/inputs/Card';
import { Col, Row, Modal } from 'react-bootstrap';
import PricingForm from './UserGroupPricingForm';
import ReactPagination from 'components/general/ReactPagination';
import DeleteModal from 'components/general/DeleteModal';
import { UPDATE_STATUS_CODE } from 'components/common/constant';
import Button from 'components/inputs/Button';
import { BiSort } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Footer from 'components/general/Footer';
import { FETCH_USER_GROUP_PRICING, GET_USER_GROUP_PRICING, DELETE_USER_GROUP_PRICING } from 'actions/userGroupPricing';
import moment from 'moment';
import SearchBox from 'components/general/SearchBox';
import { BsSearch } from 'react-icons/bs';

const UserGroupPricingList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [tariffId, setTariffId] = useState('');
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [pageWiseTariffData, setPageWiseTariffData] = useState([]);
  const [searchText, setSearchText] = useState('');

  const userGroupPricingList = useSelector((state) => state.userGroupPricing.userGroupPricing);
  const isLoader = useSelector((state) => state.userGroupPricing.isLoading);
  const page = useSelector((state) => state.userGroupPricing.page);
  const totalData = useSelector((state) => state.userGroupPricing.total);
  const limit = useSelector((state) => state.userGroupPricing.limit);
  const totalPages = useSelector((state) => state.userGroupPricing.totalPages);
  const profileData = useSelector((state) => state.profile.userProfile);
  const currentUserName = _.get(profileData, 'name', '');

  const tariffData = userGroupPricingList.filter(({ id: id1 }) => pageWiseTariffData.some(({ id: id2 }) => id2 === id1));

  const getTariff = useCallback(
    (data = {}) => {
      if (searchText) {
        const searchData = {
          ...data,
          search: searchText,
        };
        dispatch({
          type: FETCH_USER_GROUP_PRICING.REQUEST,
          payload: searchData,
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
                setPageWiseTariffData(res.data.results);
              }
            }
          },
        });
      } else {
        dispatch({
          type: FETCH_USER_GROUP_PRICING.REQUEST,
          payload: data ? data : {},
          cb: (res) => {
            if (res) {
              if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
                setPageWiseTariffData(res.data.results);
              }
            }
          },
        });
      }
    },
    [pageWiseTariffData, userGroupPricingList, searchText]
  );

  const getTariffDetail = useCallback((id) => {
    dispatch({ type: GET_USER_GROUP_PRICING.REQUEST, payload: id });
  }, []);

  useEffect(() => {
    getTariff();
  }, []);
  
  const dataFilter = useCallback(() => {
    if (searchText) {
      const filterDateData = {
        search: searchText,
      };
      getTariff(filterDateData);
    } else {
      getTariff();
    }
  }, [searchText]);

  const handleSearch = () => {
    getTariff({});
  };

  const deleteTariff = useCallback(
    () =>
      dispatch({
        type: DELETE_USER_GROUP_PRICING.REQUEST,
        payload: tariffId,
        cb: (res) => {
          if (_.get(res, 'status', '') === UPDATE_STATUS_CODE) {
            handleCloseDeleteModel();
            getTariff();
          }
        },
      }),
    [tariffId, getTariff]
  );

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (searchText) {
        const data = {
          page: page.selected + 1,
          search: searchText,
        };
        getTariff(data);
        
      } else {
        const data = {
          page: page.selected + 1,
        };
        getTariff(data);
      }
    },
    [sortByItem, searchText]
  );

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';
    if (page) {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
        page: page.selected + 1,
      };
      getTariff(data);
    } else {
      const data = {
        sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
      };
      getTariff(data);
    }
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handleCloseDeleteModel = () => {
    setShowDeleteModal(false);
    setTariffId('');
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.userGroupPricing')} />
        <div className="page-content-wrapper scrollable">
          <div className="existing-pricing__main">
            <div className="existing-pricing--block">
              <Card>
                <Row className="chargerStateList-search-box">
                  <Col xl={9} lg={9} md={8} className="chargerStateList-search-inputBox">
                    <SearchBox
                      value={searchText}
                      preIcon={<BsSearch />}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleSearch();
                        }
                      }}
                    />
                  </Col>
                  <Col xl={'auto'} lg={'auto'} md={'auto'}>
                    <div className="add-new-price" onClick={dataFilter}>
                      <Button>{t('button.search')}</Button>
                    </div>
                  </Col>
                  <Col xl={'auto'} lg={'auto'} md={'auto'}>
                    <div
                      className="add-new-price"
                      onClick={() => {
                        setShowForm(true);
                        setIsEdit(false);
                      }}
                    >
                      <Button>{t('button.addUserGroupPricing')}</Button>
                    </div>
                  </Col>
                </Row>
                <div className="pricing-list-table">
                  <div className="table-responsive">
                    <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
                      <table className="record-list-table">
                        <thead>
                          <tr key={`tariff-header-row`}>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton width={100} height={15} /> : t('addGroupPricingList.userGroup')}</span>
                                <span className="ico" onClick={() => handleSorting('name', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton width={100} height={15} /> : t('addGroupPricingList.DefaultPriceUnit')}</span>
                                <span className="ico" onClick={() => handleSorting('default_price_per_unit', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton width={100} height={15} /> : t('addGroupPricingList.action')}</span>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            <tr>
                              <td>
                                <Skeleton height={15} width={100} />
                              </td>
                              <td>
                                <Skeleton height={15} width={100} />
                              </td>
                              <td>
                                <Skeleton height={15} width={100} />
                              </td>
                              <td>
                                <Skeleton height={15} width={100} />
                              </td>
                            </tr>
                          ) : _.isEmpty(tariffData) ? (
                            <tr key={`tariff-empty-row`}>
                              <td colSpan={5}>
                                <div className="empty-data-block">{t('addGroupPricingList.noData')}</div>
                              </td>
                            </tr>
                          ) : (
                            !(isLoader || _.isUndefined(isLoader)) &&
                            _.map(tariffData, (tariff, index) => {
                              const time = moment(new Date()).format('HH:mm');
                              let price = '-';

                              if (!_.isEmpty(tariff?.schedule)) {
                                const matchedSlot = tariff.schedule.find(
                                  (slot) => time >= slot.from && time <= slot.to && !(slot.from === '00:00' && slot.to === '23:59')
                                );

                                if (matchedSlot) {
                                  price = matchedSlot.price_per_unit;
                                } else {
                                  const fallbackSlot = tariff.schedule.find((slot) => slot.from === '00:00' && slot.to === '23:59');
                                  if (fallbackSlot) {
                                    price = fallbackSlot.price_per_unit;
                                  }
                                }
                              }
                              return (
                                <tr key={`tariff-${index}`}>
                                  <td>{isLoader ? <Skeleton width={100} height={15} /> : _.get(tariff, 'user_group.name')}</td>
                                  <td>{isLoader ? <Skeleton width={100} height={15} /> : price}</td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div
                                        title="Edit Tariff"
                                        className="edit-icon"
                                        onClick={() => {
                                          setShowForm(true);
                                          getTariffDetail(tariff.id);
                                          setIsEdit(true);
                                        }}
                                      >
                                        {isLoader ? <Skeleton circle="true" width={24} height={24} /> : <FiEdit2 title="Edit" />}
                                      </div>
                                      <div
                                        title="Delete Tariff"
                                        className="delete-icon"
                                        onClick={() => {
                                          setShowDeleteModal(true);
                                          setTariffId(_.get(tariff, 'id', ''));
                                        }}
                                      >
                                        {isLoader ? <Skeleton circle="true" width={24} height={24} /> : <RiDeleteBinLine title="Delete" />}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </SkeletonTheme>
                  </div>
                </div>
                {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(tariffData) && (
                  <ReactPagination
                    currentPage={page}
                    limit={limit}
                    total={totalData}
                    handlePageClick={(pageVal) => handlePageClick(pageVal)}
                    totalPages={totalPages}
                    marginPagesDisplayed={1}
                  />
                )}
              </Card>
            </div>
          </div>
          {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
        </div>

        {showForm && (
          <Modal show={showForm} size="xl" centered>
            <PricingForm onClose={() => setShowForm(false)} isEdit={isEdit} onSuccess={getTariff} />
          </Modal>
        )}
        {showDeleteModal && (
          <Modal show={showDeleteModal} centered onHide={handleCloseDeleteModel}>
            <DeleteModal title="tariff" onClose={handleCloseDeleteModel} onRemove={deleteTariff} />
          </Modal>
        )}
      </LayoutContainer>
    </>
  );
};

export default UserGroupPricingList;
